// react
import { useState } from 'react';

// types
import { Act, LoadingStatus } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { useSearchParams } from 'react-router-dom';

// hooks
import { useFetch } from '../../../hooks/useFetch';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditAct } from '../../forms/FormEditAct/FormEditAct';

// props
export interface DialogEditActProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditAct = ({ isOpen, onClose, onSuccess }: DialogEditActProps) => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const [searchParams] = useSearchParams();
	const { t } = useTranslation();

	// params
	const paramDialogAct = searchParams.get('dialogAct');

	// state
	const [act, setAct] = useState<Act | null>(null);
	const [status, setStatus] = useState<LoadingStatus>('DEFAULT');

	// fetch act
	useFetch({
		isEnabled: Boolean(paramDialogAct && isOpen),
		url: `${process.env.REACT_APP_API_URL}/acts/${paramDialogAct}`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setAct(res.data[0]);
			}
		},
	});

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveActivity'),
					form: 'form-edit-act',
					loading: status === 'LOADING',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={500}
			onClose={onClose}
			subtitle={{
				children: act?.name,
			}}
			title={{
				children: t('editActivity'),
				variant: 'h3',
			}}>
			<FormEditAct onClose={onClose} onSuccess={onSuccess} setStatus={setStatus} />
		</DialogActions>
	);
};
